import cn from 'classnames'
import { FC, memo, useMemo } from 'react'

import styles from './CompletenessLabel.module.scss'

export interface ICompletenessLabelProps {
  completeness?: number
}

export const CompletenessLabel: FC<ICompletenessLabelProps> = memo(({ completeness }) => {
  /** -------------------- Variables ----------------------- */

  const isNA = useMemo(() => completeness === -1, [completeness])

  const completenessClassName = useMemo(() => {
    const value = completeness || 0

    return cn(styles.completenessLabel, {
      [styles.low]: value == -1,
      [styles.low]: value == 0,
      [styles.medium]: value > 0 && value < 1,
      [styles.high]: value >= 1,
    })
  }, [completeness])

  /** -------------------- Render ----------------------- */

  return (
    <div className={completenessClassName}>
      {isNA ? 'N/A' : `${((completeness || 0) * 100).toFixed(0)}%`}
    </div>
  )
})

CompletenessLabel.displayName = 'CompletenessLabel'
